<template>
  <div>
    <v-toolbar flat>
      <v-col cols="6">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          clearable
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <upload-transmittal-report-modal></upload-transmittal-report-modal>
    </v-toolbar>
    <transmittals-table
      :loading="loading"
      :transmittals="transmittals"
      :search="search"
      :isProcessed="false"
    ></transmittals-table>
  </div>
</template>
<script>
import UploadTransmittalReportModal from "./upload-transmittal-report-modal.vue";
import TransmittalsTable from "./transmittals-table.vue";
export default {
  components: {
    UploadTransmittalReportModal,
    TransmittalsTable,
  },
  async mounted() {
    this.loading = true;
    this.$store.dispatch("transmittalsModule/clearTransmittals");
    await this.$store.dispatch("transmittalsModule/getAllUnprocessedTransmittals");
    this.loading = false;
  },
  beforeDestroy() {
    this.$store.dispatch("transmittalsModule/cancelCurrentRequest");
  },
  data() {
    return {
      loading: false,
      search: "",
    };
  },
  computed: {
    transmittals() {
      return this.$store.state.transmittalsModule.transmittals || [];
    },
  },
};
</script>
